import { useNavigate } from "react-router-dom";
import { PageTitleWithNav } from "../modules/PageHeaders";
import CreateEventCalendar from "./modules/CreateEventCalendar";

export default function EventCalendarCreate() {
  const navigate = useNavigate();

  return (
    <section className=" px-lg-3  min-vh-100 pb-5 mb-5">
      <PageTitleWithNav
        title={"Create Event"}
        action={() => navigate("/super_admin/event_calendar")}
      />
      <div className="py-1"></div>
      <CreateEventCalendar onNext={() => {}} />
    </section>
  );
}
